// extracted by mini-css-extract-plugin
module.exports = {"icon_3otNL1":"icon_3otNL1","asset-image_3nC7FR":"asset-image_3nC7FR","lg_1OCYGV":"lg_1OCYGV","md_1hzEpu":"md_1hzEpu","sm_11RaCk":"sm_11RaCk"};